/**
 * @file tts相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';

/**
 * 获取 TTS 声音设置面板配置项
 * @returns Promise
 */
export const getTTSConfigList = async params => {
    return request(
        API.GET_TTS_CONFIG_CONFIG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取 TTS 音色列表
 * @returns Promise
 */
export const getTimbreList = async params => {
    return request(
        API.GET_TIMBRE_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取 TTS 风格列表
 * @returns Promise
 */
export const getMoodList = async params => {
    return request(
        API.GET_MOOD_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取文本语音试听
 * @returns Promise
 */
export const getTTSPreviewUrl = async params => {
    return request(
        API.GET_TTS_PREVIEW_URL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取 TTS 预览任务id
 * @returns Promise
 */
export const getTextAudio = async params => {
    return new Promise(async (resolve, reject) => {
        const taskRes = await request(
            API.GET_TTS_PREVIEW_JOB, {
                method: 'POSTJSON',
                body: params
            }
        );

        let jobInterval;
        let timeout = setTimeout(() => {
            clearInterval(jobInterval);
            reject();
        }, 50000);

        if (taskRes && taskRes.data) {
            jobInterval = setInterval(async () => {
                const res = await getTTSPreviewUrl({job_id: taskRes.data});

                if (res && (res.data || {}).url) {
                    clearTimeout(timeout);
                    clearInterval(jobInterval);
                    resolve(res.data.url);
                }
            }, 2000);
        }
    });
};

/**
 * 获取tts流式预览auth签名
 * @returns Promise
*/
export const getTTSPreviewAuth = async params => {
    return request(
        API.GET_TTS_PREVIEW_AUTH, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取tts音频列表
 * @returns Promise
*/
export const getTTSVoice = async params => {
    return request(
        API.GET_TTS_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取tts标签列表
 * @returns Promise
*/
export const getTTSTag = async params => {
    return request(
        API.GET_TTS_TAG_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取克隆tts音频列表
 * @returns Promise
*/
export const getCloneTTSVoice = async params => {
    return request(
        API.GET_TTS_CLONE_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取收声制作音频列表
 * @returns Promise
*/
export const getSwanTTSVoice = async params => {
    return request(
        API.GET_TTS_SWAN_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 更新克隆音库
 * @returns Promise
*/
export const updateCloneTTS = async params => {
    return request(
        API.UPDATE_TTS_CLONE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取tts收藏列表
 * @returns Promise
*/
export const getTTSCollectionList = async params => {
    return request(
        API.GET_TTS_COLLECTION_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 添加tts收藏
 * @returns Promise
*/
export const addTTSCollection = async params => {
    return request(
        API.GET_TTS_COLLECTION_ADD, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 删除tts收藏
 * @returns Promise
*/
export const delTTSCollection = async params => {
    return request(
        API.GET_TTS_COLLECTION_DEL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 提交ASR任务
 * @returns Promise
 */
export const postAsrTask = async params => {
    return request(
        API.SUBMIT_ASR_JOB, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取ASR任务进度
 * @returns Promise
 */
export const getAsrProcess = async params => {
    return request(
        API.SUBMIT_ASR_DETAIL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/*
 * 检查文案多音字及数字
 * @param {*} params
 * @returns
 */
export const checkSayas = async params => {
    return request(
        API.CHECK_SAYAS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取tts文字时长
 * @param {*} params
 * @returns
 */
export const getTTSDuration = async params => {
    return request(
        API.GET_TTS_DURATION, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取时长进度查询
 * @param {*} params
 * @returns
 */
export const getTTSDurationProgress = async params => {
    return request(
        API.GET_TTS_DURATION_PROGRESS, {
            method: 'POSTJSON',
            body: params
        });
};

/**
 * 调整视频音量
 * @param {*} params
 * @returns
 */
export const changeVolumeByVideo = async params => {
    return request(
        API.CHANGE_VOLUME, {
            method: 'POSTJSON',
            body: params
        });
};

export default {
    getTTSConfigList,
    getTimbreList,
    getMoodList,
    getTTSPreviewUrl,
    getTextAudio,
    getTTSPreviewAuth,
    getTTSVoice,
    getTTSTag,
    getCloneTTSVoice,
    updateCloneTTS,
    getTTSCollectionList,
    addTTSCollection,
    delTTSCollection
};
